export const kiosk = {
  seo: {
    title: 'Self-order kiosk for restaurants | Bistroo',
    description: 'The Bistroo kiosk lets guests order independently on-site. Shorter queues, higher revenue. Ask about the possibilities.',
  },
  hero: {
    title: {
      pt1: 'An',
      pt2: 'ordering kiosk',
      pt3: 'that grows your revenue on autopilot',
    },
    description:
      'The Bistroo Kiosk lets guests order at their own pace, freeing up your staff for what truly matters. More orders, higher order values and shorter queues without extra effort.',
  },
  paragraphs: {
    paragraph_1: {
      title: 'More revenue, shorter wait times',
      text: 'A self-service kiosk increases average order value by up to 25%, as guests take their time to browse and are more likely to accept upsell suggestions. Meanwhile, your team handles more orders in less time, without extra staff at the counter.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_2: {
      title: 'Interactive design in your own branding',
      text: "Fully personalize the kiosk in the colors and style of your brand. From the welcome screen to the order confirmation, everything seamlessly matches your restaurant's branding. This makes the Bistroo Kiosk a true eye-catcher that fits perfectly within your concept.",
      cta: '',
    },
    paragraph_3: {
      title: 'Fast, clear and organized ordering',
      text: 'Every order placed through the Bistroo Kiosk automatically receives an order number and receipt, making pickup simple for customers and easy to manage for staff. A smooth ordering experience for both individual locations and enterprise chains.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_4: {
      title: 'Full control via the Bistroo Manager',
      text: 'The last thing you want as a restaurant or food shop owner is having to call someone to change your menu. We give you complete control over your data, products, customers and orders!',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Self-service ordering, less pressure at the counter.',
        text: 'Guests order at their own pace via the touchscreen. Your staff gains more time for service, preparation and quality.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Integrations.',
        text: 'Easily connect the kiosk to your POS system, kitchen display or other tools.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Smart upselling.',
        text: 'Set up automatic suggestions with every order and effortlessly increase average order value.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Boost revenue.',
        text: 'Restaurants see on average up to 25% more revenue after introducing an ordering kiosk.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Promotions and loyalty.',
        text: 'Set up discounts, promotions and loyalty rewards that are immediately visible on the kiosk.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Since introducing the Bistroo Kiosk, queues are noticeably shorter and guests order more than before. Our staff finally has time for real hospitality."',
    cta: 'Read the full story',
    name: 'Thomas Hendriks',
    job_title: 'Owner La Bella Cucina',
  },
  faq: {
    title_pt1: 'All about the',
    title_pt2: 'Bistroo Kiosk',
    items: [
      { q: 'What is the Bistroo Kiosk and who is it for?', a: 'The Bistroo Kiosk is a self-service ordering kiosk for restaurants, food shops and hospitality chains. Guests order independently via a touchscreen, resulting in shorter queues and a higher average order value.' },
      { q: 'How do I install the ordering kiosk?', a: 'The kiosk is plug-and-play. After delivery, switch it on, connect it to your Wi-Fi and it is ready to use. Bistroo guides you through the initial setup and connection to your existing systems.' },
      { q: 'Can I customize the kiosk to match my own branding?', a: 'Absolutely. You can fully personalize the welcome screen, colors and style to match your brand. From the first image to the order confirmation, everything seamlessly aligns with your branding.' },
      { q: 'How are kiosk orders processed?', a: 'Every kiosk order automatically receives an order number and receipt. The order is sent directly to the kitchen printer or POS system, just like a regular online order.' },
      { q: 'Which payment methods does the kiosk support?', a: 'The Bistroo Kiosk supports card payments (contactless and chip) and mobile payment methods such as Apple Pay and Google Pay. Cash payment is optional depending on your setup.' },
      { q: 'How does upselling work on the kiosk?', a: 'You configure automatic suggestions per product or category in the Bistroo Manager. At the right moment in the ordering process, the guest sees a relevant suggestion, which noticeably increases the average order value.' },
      { q: 'Can the kiosk be connected to my POS system?', a: 'Yes. The Bistroo Kiosk integrates with all common POS systems. Orders flow automatically to your kitchen or till without any manual intervention.' },
      { q: 'How do I manage the menu on the kiosk?', a: 'Your kiosk menu is always synchronized with the Bistroo Manager. Update a price, deactivate a product or add a promotion and the kiosk reflects this immediately.' },
      { q: 'What does the Bistroo Kiosk cost?', a: 'The cost consists of the rental or purchase of the hardware device plus a monthly software fee. Contact us via bistroo.nl for a tailored quote for your situation.' },
      { q: 'How much extra revenue does an ordering kiosk generate on average?', a: 'Restaurants that introduce the Bistroo Kiosk see on average up to 25% more revenue per order. Guests take more time to browse and are more likely to add extras when they are not under the time pressure of a queue.' },
    ],
  },
}
